import styled from 'styled-components';

import colors from 'app/styles/theme/colors';
import typography from 'app/styles/theme/typography';
import { fontSizes } from 'app/styles/theme/sizes';

const { gray, green, red } = colors.designSystem;

// Overlay, largura, fundo e cantos vêm do ModalDialog (MUI Dialog): aqui sobra
// o que é do conteúdo — a âncora do × e a fonte.
export const Card = styled.div`
  position: relative;
  font-family: ${typography.quartenary};
`;

export const Illustration = styled.img`
  display: block;
  width: 100%;
  height: auto;
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 11px;
  right: 11px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: transparent;
  color: ${gray[950]};
  font-family: inherit;
  font-size: ${fontSizes.xxl};
  line-height: 1;
  cursor: pointer;

  &:hover,
  &:focus-visible {
    background: ${gray[200]};
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.48;
  }
`;

export const Body = styled.div`
  padding: 20px 48px 40px;
  text-align: center;

  @media (max-width: 480px) {
    padding: 20px 24px 32px;
  }
`;

export const Title = styled.strong`
  display: block;
  color: ${gray[950]};
  font-size: ${fontSizes.xl};
  font-weight: 700;
  line-height: 1.4;
`;

export const Description = styled.p`
  margin: 4px 0 0;
  color: ${gray[950]};
  font-size: ${fontSizes.sm};
  line-height: 1.4;
`;

export const AnswerError = styled.p`
  margin: 12px 0 0;
  color: ${red[500]};
  font-size: ${fontSizes.sm};
  line-height: 1.4;
`;

export const Actions = styled.div`
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-top: 32px;

  @media (max-width: 480px) {
    flex-direction: column-reverse;
  }
`;

const answerButton = `
  min-width: 176px;
  padding: 8px 24px;
  border-radius: 8px;
  font-family: inherit;
  font-size: ${fontSizes.sm};
  font-weight: 600;
  line-height: 1.4;
  cursor: pointer;

  &:disabled {
    cursor: default;
    opacity: 0.6;
  }

  @media (prefers-reduced-motion: no-preference) {
    transition: background 0.15s ease, border-color 0.15s ease;
  }
`;

export const DeclineAnswer = styled.button`
  ${answerButton};
  border: 1px solid ${gray[500]};
  background: ${gray[0]};
  color: ${gray[950]};

  &:hover,
  &:focus-visible {
    background: ${gray[100]};
    border-color: ${gray[600]};
  }
`;

export const ConfirmAnswer = styled.button`
  ${answerButton};
  border: 1px solid ${green[500]};
  background: ${green[500]};
  color: ${gray[0]};

  &:hover,
  &:focus-visible {
    background: ${green[600]};
    border-color: ${green[600]};
  }
`;
